/** Site brand — used in SEO, structured data, and static copy. */
export const SITE_NAME = 'Bloomwik';
export const SITE_TAGLINE = 'Stories & Insights';
export const SITE_EMAIL = 'hello@bloomwik.com';
export const SITE_DOMAIN = 'bloomwik.com';
